<div
  class="steps-container d-flex flex-wrap"
  cdkDropList
  (cdkDropListDropped)="drop($event)"
  id="{{ 'section-' + wfSectionID }}"
  [cdkDropListConnectedTo]="sectionDropLists"
  [cdkDropListData]="steps"
  [cdkDropListDisabled]="disabled"
  [cdkDropListOrientation]="'horizontal'"
>
  <div
    *ngFor="let step of steps"
    class="flex-auto"
    [ngClass]="{ 'full-width': step.fullWidth }"
    cdkDrag
    (cdkDragMoved)="service.onDragMoved($event)"
    [cdkDragDisabled]="disabled || service.taskHover"
    cdkDragAutoScroll="true"
  >
    <div
      class="step-wrapper d-flex relative full-height"
      (mouseenter)="service.stepHover = true"
      (mouseleave)="service.stepHover = false"
    >
      <div
        class="drag-handler-container"
        *ngIf="!disabled && !service.taskHover"
      >
        <button
          mat-icon-button
          cdkDragHandle
          color="accent"
          style="cursor: move"
        >
          <mat-icon>reorder</mat-icon>
        </button>
      </div>
      <workflow-step
        id="step-{{ step.id }}"
        class="full-width"
        [wfTableConfig]="wfTableConfig"
        [step]="step"
        [stepDropLists]="stepDropLists"
        [disabled]="disabled"
        (delete)="delete($event)"
        (duplicate)="duplicate($event)"
      ></workflow-step>
    </div>
  </div>
</div>
<!-- <button
  mat-stroked-button
  class="ml-1"
  color="accent"
  *ngIf="!disabled"
  (click)="add()"
  [matTooltip]="'Add New Step'"
>
  <mat-icon>add_box</mat-icon> Add Step
</button> -->
